module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/event-license-block/event-license-block.component.scss
// module id = ./src/app/modules/backstage-module/components/event-license-block/event-license-block.component.scss
// module chunks = 9